module.exports = __webpack_public_path__ + "img/img0.e858837d.jpg";